import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime, toConsumableArray as _toConsumableArray, typeof as _typeof } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { FormControl } from './FormControl.js';
import debounce from 'lodash/debounce.js';
import isEqual from 'lodash/isEqual.js';
import { multiSelectPropTypes, defaultMultiselectProps, checkSelectError, rendererProps, translationProps, getFormattedValue, autoComplete, getDefaultOptionValue, getDefaultOptionLabel, selectOnChange, getSelectData, onFocus } from '../ControlHelpers/SelectUtils.js';
import { selectTheme, selectControlStyles } from './SelectControl.styles.js';
import AsyncCreatable from 'react-select/async-creatable';
import AsyncSelect from 'react-select/async';
import { selectComponents } from './SelectComponentWrappers.js';
var _excluded = ["id", "data"],
    _excluded2 = ["className", "cacheEnabled", "clearable", "creatable", "disabled", "isClearable", "isDisabled", "isMulti", "isSearchable", "multi", "placeholder", "placeholderText", "searchable"];

var SelectAsyncControl = /*#__PURE__*/function (_FormControl) {
  function SelectAsyncControl(_props) {
    var _this;

    _classCallCheck(this, SelectAsyncControl);

    _this = _callSuper(this, SelectAsyncControl, [_props]);

    _defineProperty(_this, "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          dataUrl = _this$props.dataUrl,
          dataValue = _this$props.dataValue,
          filters = _this$props.filters,
          valueOverride = _this$props.valueOverride,
          isLegacyOverride = _this$props.isLegacyOverride;

      if (!isEqual(filters, filters) || prevProps.dataUrl !== dataUrl) {
        _this.onChange();
      }

      if (valueOverride && dataValue !== _this.state.value) {
        _this.onChange(dataValue, isLegacyOverride);
      }
    });

    _defineProperty(_this, "onChange", function (val, skipValueChange) {
      var _this$select; // react-select would return a metadata object sometimes as this method is used directly on it's onChange prop (https://react-select.com/props#:~:text=void-,onChange,-Handle%20change%20events)
      // we don't want that, only boolean values


      var skip = typeof skipValueChange === 'boolean' && skipValueChange;
      var value = selectOnChange(val, _this.props, (_this$select = _this.select) === null || _this$select === void 0 ? void 0 : _this$select.current, skip);

      _this.setState(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), {}, {
          value: value
        });
      });
    });

    _defineProperty(_this, "getData", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(input, callback) {
        var _this$props2, clientSideFilter, defaultOptions, disabledOptionsIds, options, optionsArr, _optionsArr;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setState({
                  isLoading: true
                });

                _this$props2 = _this.props, clientSideFilter = _this$props2.clientSideFilter, defaultOptions = _this$props2.defaultOptions, disabledOptionsIds = _this$props2.disabledOptionsIds;
                _context.next = 4;
                return getSelectData(input, _this.props, clientSideFilter);

              case 4:
                options = _context.sent;
                optionsArr = options === null || options === void 0 ? void 0 : options.map(function (_ref2) {
                  var id = _ref2.id,
                      data = _ref2.data,
                      props = _objectWithoutProperties(_ref2, _excluded);

                  return _objectSpread2(_objectSpread2(_objectSpread2({}, props), data), {}, {
                    value: id
                  });
                });

                if (defaultOptions) {
                  (_optionsArr = optionsArr).unshift.apply(_optionsArr, _toConsumableArray(defaultOptions));
                }

                if (disabledOptionsIds !== null && disabledOptionsIds !== void 0 && disabledOptionsIds.length) {
                  optionsArr = optionsArr.filter(function (option) {
                    return !disabledOptionsIds.includes(option.id);
                  });
                }
                /*
                 * We need this here due to a current bug in react-select v5, which causes that if an options
                 * property is part of the returned entities, the library thinks we want to create groups.
                 * They have not fixed it yet but are aware of it: https://github.com/JedWatson/react-select/issues/3706
                 * Here is the check: https://github.com/JedWatson/react-select/blob/c22a4b20aef2161ebaa3a0373de7e0e179e73693/packages/react-select/src/Select.js#L1315
                 */


                optionsArr.forEach(function (opt) {
                  if (opt.options) {
                    /* some of our data objects, namely Templates in Notifi, have an attribute called options, that we need, so this renames them as well as deleting them. */
                    opt.optionsAttr = opt.options;
                  }

                  delete opt.options;
                });

                _this.setState({
                  isLoading: false,
                  options: optionsArr
                });

                callback(optionsArr);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_this, "onFocus", function (e) {
      onFocus(e, _this.props);
    });

    _defineProperty(_this, "checkAndLoadOptions", function (input, callback) {
      if (!input && _this.props.requireInput) {
        return Promise.resolve({
          options: []
        });
      } else {
        _this.debouncedGetData(input, callback);
      }
    });

    _defineProperty(_this, "onBlur", function () {
      if (typeof _this.props.onBlur === 'function') {
        _this.props.onBlur(_this.state.value);
      }

      _this.checkError();
    });

    _defineProperty(_this, "isValid", function () {
      return _this.input.validity.valid;
    });

    _defineProperty(_this, "handleOnMenuOpen", function () {
      return _this.setState({
        isMenuOpen: true
      });
    });

    _defineProperty(_this, "handleOnMenuClose", function () {
      return _this.setState({
        isMenuOpen: false
      });
    });

    _defineProperty(_this, "handleOnKeyDown", function (event) {
      if (event.key === 'Enter' && !_this.state.isMenuOpen) {
        _this.handleOnMenuOpen();
      }
    });

    var _value = _props.initialData;

    if (_value && !_value.display && _typeof(_value) === 'object') {
      if (_props.buildDisplay) {
        _value.display = _props.buildDisplay(_value);
      } else {
        _value.display = _value[_props.displayProperty];
      }
    }

    _this.state = {
      isLoading: false,
      options: [],
      value: _value,
      isMenuOpen: false
    };
    _this.debouncedGetData = debounce(_this.getData, _props.valueChangeDelay, {
      leading: false,
      trailing: true
    });
    _this.select = /*#__PURE__*/React.createRef();
    return _this;
  }

  _inherits(SelectAsyncControl, _FormControl);

  return _createClass(SelectAsyncControl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var value = this.state.value;

      if (value && value.display) {
        this.onChange(value);
      }
    }
  }, {
    key: "checkError",
    value: function checkError() {
      var _this$select2;

      checkSelectError(this.props, (_this$select2 = this.select) === null || _this$select2 === void 0 ? void 0 : _this$select2.current);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _props$valueKey;

      var _this$props3 = this.props,
          className = _this$props3.className,
          cacheEnabled = _this$props3.cacheEnabled,
          clearable = _this$props3.clearable,
          creatable = _this$props3.creatable,
          disabled = _this$props3.disabled,
          isClearable = _this$props3.isClearable,
          isDisabled = _this$props3.isDisabled,
          isMulti = _this$props3.isMulti,
          isSearchable = _this$props3.isSearchable,
          multi = _this$props3.multi,
          placeholder = _this$props3.placeholder,
          placeholderText = _this$props3.placeholderText,
          searchable = _this$props3.searchable,
          props = _objectWithoutProperties(_this$props3, _excluded2);

      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          options = _this$state.options,
          value = _this$state.value;
      var isClearableSelect = !(clearable === false || isClearable === false);
      var isDisabledSelect = disabled || isDisabled || false;
      var isMultiSelect = multi || isMulti || false;
      var formattedName = isMultiSelect ? props.name + '[]' : props.name;
      var isSearchableSelect = searchable || isSearchable;
      var SelectedComponent = creatable ? AsyncCreatable : AsyncSelect;
      var classPrefix = "Select".concat(props.name ? "-".concat(props.name) : '');

      var Option = function Option(props) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/prop-types
          React.createElement("div", _extends({
            ref: props.innerRef
          }, props.innerProps, props), /*#__PURE__*/React.createElement(selectComponents.Option, props))
        );
      };

      var components = _objectSpread2(_objectSpread2({}, selectComponents), {}, {
        Option: Option
      });

      return /*#__PURE__*/React.createElement(SelectedComponent, _extends({}, props, rendererProps(isMultiSelect, this.props), translationProps, {
        "aria-labelledby": "".concat(props.name, "-label"),
        cacheOptions: cacheEnabled,
        className: className !== null && className !== void 0 ? className : classPrefix,
        classNamePrefix: "Select-",
        closeMenuOnSelect: !isMultiSelect,
        components: components,
        defaultOptions: true,
        getOptionLabel: function getOptionLabel(option) {
          return getDefaultOptionLabel(option, _this2.props);
        },
        getOptionValue: function getOptionValue(option) {
          return getDefaultOptionValue(option, _this2.props);
        },
        inputId: "".concat(classPrefix, "-input"),
        inputProps: autoComplete(this.props),
        instanceId: "".concat(props.name ? "".concat(props.name, "-") : '', "value"),
        isClearable: isClearableSelect,
        isDisabled: isDisabledSelect,
        isLoading: isLoading,
        isMulti: isMultiSelect,
        isSearchable: isSearchableSelect,
        labelKey: "display",
        loadOptions: this.checkAndLoadOptions,
        name: formattedName,
        onBlur: this.onBlur,
        onChange: this.onChange,
        onOpen: this.onOpen,
        placeholder: placeholderText || placeholder,
        ref: this.select,
        removeSelected: false,
        scrollMenuIntoView: false,
        styles: selectControlStyles({
          isMultiSelect: isMultiSelect,
          value: value
        }),
        theme: selectTheme,
        value: getFormattedValue(value, options, this.props),
        valueKey: (_props$valueKey = props.valueKey) !== null && _props$valueKey !== void 0 ? _props$valueKey : props.valueProperty,
        hideSelectedOptions: false,
        onMenuOpen: this.handleOnMenuOpen,
        onMenuClose: this.handleOnMenuClose,
        menuIsOpen: this.state.isMenuOpen,
        onKeyDown: this.handleOnKeyDown
      }));
    }
  }]);
}(FormControl);

_defineProperty(SelectAsyncControl, "propTypes", multiSelectPropTypes);

_defineProperty(SelectAsyncControl, "defaultProps", defaultMultiselectProps);

SelectAsyncControl.displayName = "SelectAsyncControl";
export { SelectAsyncControl };